/**
 *  @license
 *    Copyright 2018 Brigham Young University
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 **/
'use strict'

// export state as a function
export const state = () => ({
  selectedGroup: {},
  selectedPerson: {},
  selectedResource: {},
  groupsInfoArea: undefined,
  disableCreate: undefined,
  recentlyAddedGroupMemberships: {}
})

// export mutations object
export const mutations = {
  updateSelectedGroup (state, new_group) {
    state.selectedGroup = new_group
  },
  updateSelectedPerson (state, new_person) {
    state.selectedPerson = new_person
  },
  updateSelectedResource (state, new_resource) {
    state.selectedResource = new_resource
  },
  updateGroupsInfoArea (state, input) {
    state.groupsInfoArea = input
  },
  disableCreate (state, input) {
    state.disableCreate = input
  },addRecentlyAddedGroupMembership
   (state, input) {
    if (!state.recentlyAddedGroupMemberships[input.group_id]) {
      state.recentlyAddedGroupMemberships[input.group_id] = []
    }
    state.recentlyAddedGroupMemberships[input.group_id].push(input.member)
  },
  updateRecentlyAddedGroupMembership (state, input) {
    let i = state.recentlyAddedGroupMemberships[input.group_id].findIndex(member => {
      return member.byu_id.value === input.member.byu_id.value
    })
    state.recentlyAddedGroupMemberships[input.group_id][i] = input.member
  },
  deleteRecentlyAddedGroupMembership (state, input) {
    let i = state.recentlyAddedGroupMemberships[input.group_id].findIndex(member => {
      return member.byu_id.value === input.member.byu_id.value
    })
    state.recentlyAddedGroupMemberships[input.group_id].splice(i, 1)
  }
}
